import * as accounting from 'accounting';
import * as api from '../api';
import * as i18next from 'i18next';
import * as utils from 'core/utils';
import { G2S } from '../g2s';

export class Filters {
    static baggage(value: api.FlightBaggage): string {
        if (!value) { return ''; }

        if (value.pieceWeight == 0 && value.pieces == 0) {
            return i18next.t('label_baggage_without_short');
        }

        if (value.pieceWeight > 0) {
            let result = value.pieceWeight + i18next.t('label_kg');

            if (value.pieces > 1) {
                result = value.pieces + G2S.nbsp + 'x' + G2S.nbsp + result;
            }

            return result;
        } else {
            if (value.pieces > 0) {
                return i18next.t('numerous_baggage_piece', { count: value.pieces });
            }
        }

        return '';
    }

    static customBaggage(value: api.CustomBaggageItem): string {
        if (!value) { return ''; }

        if (value.bagsQuantity === 0) {
            return i18next.t('label_baggage_without');
        } else {
            let result = i18next.t('numerous_baggage_piece_long', { count: value.bagsQuantity });

            if (value.bagsWeight && value.bagsWeight != '0') {
                result += ' ('
                    + value.bagsWeight
                    + i18next.t('label_kg')
                    + ')';
            }

            return result;
        }
    }

    static number(value: any, addPlus: boolean): string {
        if (!value) { value = 0; }

        value = Math.round(value);

        return (addPlus ? '+ ' : '') + accounting.formatNumber(value,
            {
                thousand: ' ',
                precision: 0
            })
            .replace(/ /g, '\xA0');
    }

    static phone(value: any): string {
        if (!value) { return ''; }

        const parsed = value.toString().trim().replace(/^\+/, '');

        if (parsed.match(/[^0-9]/)) {
            return value;
        }

        if (parsed.length == 11 && parsed[0] == 7) {
            return ('+7' +
                ' ' + parsed.substring(1, 4) + ' ' +
                parsed.substring(4, 7) + '-' +
                parsed.substring(7, 9) + '-' +
                parsed.substring(9)
            ).trim();
        }

        return value;
    }

    static price(value: any, addPlus: boolean, symbol?: string): string {
        if (!value) { value = 0; }
        
        value = G2S.config.locale === 'ru' ? Math.round(value) : Math.round(value * 100) / 100;

        return (addPlus && value > 0 ? '+ ' : '') + accounting.formatMoney(value,
            {
                symbol: symbol ? utils.String.currencySymbol(symbol) : G2S.config.currencySymbol,
                thousand: (symbol || G2S.config.currencyCode) === 'USD' ? ',' : ' ',
                precision: G2S.config.locale === 'ru' ? 0 : 2,
                format: (symbol || G2S.config.currencyCode) === 'USD' ? '%s%v' : '%v %s'
            })
            .replace(/ /g, '\xA0');
    }

    static priceWithCurrency(value: any, currency: string, addPlus: boolean): string {
        if (!value) { value = 0; }

        value = Math.round(value);

        return (addPlus && value > 0 ? '+ ' : '') + accounting.formatMoney(value,
            {
                symbol: currency,
                thousand: ' ',
                precision: 0,
                format: '%v %s'
            })
            .replace(/ /g, '\xA0');
    }
}
